(function () {
  const syncId5AbovePrice = (sectionId) => {
    if (!document.documentElement.classList.contains('product-layout-id5-variant')) return;
    if (window.matchMedia('(min-width: 750px)').matches) return;

    const source = document.getElementById(`price-${sectionId}`);
    const target = document.querySelector(
      `#MainProduct-${sectionId} [data-id5-above-gallery] .product-page-price--id5-above`
    );
    if (!source || !target) return;

    const sourceContainer = source.querySelector('.price__container');
    const targetContainer = target.querySelector('.price__container');
    if (sourceContainer && targetContainer) {
      targetContainer.innerHTML = sourceContainer.innerHTML;
    }
  };

  const initSection = (sectionId) => {
    syncId5AbovePrice(sectionId);

    const source = document.getElementById(`price-${sectionId}`);
    if (!source) return;

    const observer = new MutationObserver(() => syncId5AbovePrice(sectionId));
    observer.observe(source, { childList: true, subtree: true, characterData: true });

    document.addEventListener('change', (event) => {
      const variantSelects = event.target?.closest?.(`variant-selects[data-section="${sectionId}"]`);
      if (variantSelects) syncId5AbovePrice(sectionId);
    });
  };

  const initAll = () => {
    document.querySelectorAll('product-info[data-section]').forEach((el) => {
      initSection(el.dataset.section);
    });
  };

  document.addEventListener('DOMContentLoaded', initAll);

  const htmlClassObserver = new MutationObserver(initAll);
  document.addEventListener('DOMContentLoaded', () => {
    htmlClassObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail?.sectionId;
    if (sectionId) initSection(sectionId);
  });
})();
